<style lang="scss" scoped>
.index4 {
  position: relative;
  top: 112px;
  .qrCodeBox {
    width: 888px;
    background: #ffffff;
    border-radius: 2px;
    margin: 0 auto;
    text-align: center;
    .title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      letter-spacing: 1px;
      padding-top: 64px;
    }
    .descBox {
      width: 610px;
      height: 66px;
      background: #f2fbff;
      border-radius: 2px;
      border: 1px solid #ccecff;
      margin: 0 auto;
      line-height: 66px;
      margin: 27px auto 36px auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1890ff;
    }
    .qrCode {
      width: 210px;
      height: 210px;
      background: #ffffff;
      text-align: center;
      margin: 0 auto;
      img {
        width: 180px;
        height: 177px;
      }
    }
    .name {
      width: 335px;
      height: 50px;
      background: #f6f8fb;
      line-height: 50px;
      margin: 43px auto 97px auto;
      font-size: 17px;
    }
    .footBar {
      width: 828px;
      border-top: 1px solid #dddddd;
      line-height: 50px;
      height: 50px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin: 0 auto;
      text-align: center;
      color: #2083e0;
    }
  }
}
</style>
<template>
  <div class="index4">
    <div class="qrCodeBox">
      <div class="title">
        还差最后一步了，快添加客服配置吧！
      </div>
      <div class="descBox">
        <span>因API限制，需在进行设置后才可正常使用，请添加专属客服，我们会帮您进行配置</span>
      </div>
      <div class="qrCode">
        <img
          :src="require('@/assets/img/qwLogin/CS2code.png')"
          alt=""
        >
      </div>
      <div
        class=""
        style="margin-top: 6px"
      >
        添加专属客服，轻松完成企业微信配置
      </div>
      <!-- <div class="name">
        这里是刚才授权的企业名
      </div> -->
      <div style="padding: 40px">
        <el-button
          type="primary"
          @click="$router.push({ path: '/qwAuth/createdApp', replace: true })"
        >
          我已添加，自行配置
        </el-button>
      </div>
      <!-- <div class="footBar view-flex view-flex-center">
        <el-button
          type="text"
          @click="$router.push({ path: '/qwAuth/createdApp' })"
        >
          我要自己配置
        </el-button>
        <div style="color: grey">
          （强烈不推荐）
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      form: {}
    }
  },
  computed: {},
  watch: {},
  mounted () {
    console.log('bindCS', this.companyInfo)
    // let qw = this.$store.getters.companyInfo
  },
  methods: {}
}
</script>
